import { useMutation } from '@tanstack/react-query';

import { videoCallService } from '../services';

/**
 * Mutation hook for POST /sessions/:id/call/end on elixaa-realtime.
 * Practitioner + admin only (enforced server-side). Consumers wire
 * this to the explicit End-call action after a ConfirmDialog; the
 * route then calls room.disconnect() regardless of mutation outcome
 * so the practitioner isn't trapped on a server error.
 */
export function useEndCall() {
  return useMutation({
    mutationFn: (sessionId: string) => videoCallService.endCall(sessionId),
  });
}
